<template>
  <v-dialog :value="show" @input="$emit('update:show', $event)" max-width="480">
    <v-card>
      <v-card-title class="headline">Экспорт базы</v-card-title>

      <v-card-text>
        <v-select
          v-model="exportType"
          :items="options"
          label="Что экспортировать?"
          item-text="label"
          item-value="value"
          outlined
        />
      </v-card-text>

      <v-card-actions class="justify-end">
        <v-btn text @click="close">Отмена</v-btn>
        <v-btn color="#FEE600" dark @click="exportData" :disabled="!exportType">
          Скачать
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    guid: [String, Array],
    show: Boolean,
  },
  data() {
    return {
      exportType: null,
      options: [
        { label: 'Только база',           value: 'base'  },
        { label: 'Только чёрный список',  value: 'black' },
        { label: 'База и чёрный список',  value: 'both'  },
      ],
    };
  },
  methods: {
    close() {
      this.$emit('update:show', false);
      this.exportType = null;
    },

    async exportData() {
      try {
        const token   = localStorage.token || '';
        const payload = Array.isArray(this.guid)
          ? { ids: this.guid, type: this.exportType, token }
          : { id : this.guid, type: this.exportType, token };

        /* ── здесь вызываем именно axios, а не post() ── */
        const { data } = await this.$http.axios.post(
          '/base/export',
          payload,
          { responseType: 'blob' }
        );

        /* ── сохранение файла ── */
        const blob = new Blob([data]);
        const url  = URL.createObjectURL(blob);

        const filename =
          Array.isArray(this.guid) && this.guid.length > 1
            ? 'bases.zip'
            : `${payload.id || payload.ids[0]}.xlsx`;

        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();

        URL.revokeObjectURL(url);
        this.close();
      } catch (e) {
        console.error(e);
        this.$toast.error('Не удалось экспортировать');
      }
    },
  },
};
</script>

